/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Definitions/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaInputWithLabelField from 'DesignSystem/TysiaInputWithLabelField/index'



/** @type {import('Simple/types.js').View} */
export default function Definitions({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Onboarding/CsvTxCardFields/Definitions",
  isInvalid,
  onChange
  
}) {
let dataTxCardFieldDefinitionsCsvIsValidData = fromData.useDataIsValid({ viewPath,
context: 'data',
path: 'tx_card_field_definitions_csv',
validate: fromHelpers.validate,
required: true,
})
let dataTxCardFieldDefinitionsCsvChangeData = fromData.useDataChange({ viewPath,
context: 'data',
path: 'tx_card_field_definitions_csv',
})
let dataTxCardFieldDefinitionsCsvNameValueData = fromData.useDataValue({ viewPath,
context: 'data',
path: 'tx_card_field_definitions_csv.name',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaInputWithLabelField
  viewPath={`${viewPath}/TysiaInputWithLabelField`}
 type="file"
 label="IC1-vaxiom.tx_card_field_definitions.csv"
 marginLeft={dtSpaceXs}
 data="data.tx_card_field_definitions_csv"
 required={true}
 validate="helpers.js validate"
 invalid={!dataTxCardFieldDefinitionsCsvIsValidData}
 onChange={dataTxCardFieldDefinitionsCsvChangeData}
 data="data.tx_card_field_definitions_csv.name"
 value={dataTxCardFieldDefinitionsCsvNameValueData}
/>
{children}
</React.Fragment>)
}